import React from "react";
import { Row, Button, Col} from "antd";
import imgEdificio from "../../../img/edificio.svg";
import * as etiquetas from '../../../ApplicationResources';

class JuntaEjecutivaConsulta extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <Row>
                <Col xs={22} sm={22} md={22} lg={22} offset={2}>
                    <Col xs={24} sm={24} md={4} lg={6} className="columna1_junta_ejecutiva">
                        <img src={imgEdificio} />
                    </Col>
                    <Col xs={24} sm={24} md={18} lg={16} className="columna2_junta_ejecutiva">
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            { etiquetas.ETIQUETA_JUNTA_EJECUTIVA_NOMBRE_JUNTA }
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {this.props.informacionJunta ? this.props.informacionJunta.nombreJunta : "-"}
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_DOMICILIO}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {
                                this.props.informacionJunta && this.props.informacionJunta.calle && this.props.informacionJunta.numeroExterior &&
                                this.props.informacionJunta.colonia && this.props.informacionJunta.codigoPostal && this.props.informacionJunta.nombreMunicipio
                                && this.props.informacionJunta.nombreEstado ? 
                                "Calle " + this.props.informacionJunta.calle + ", No. Exterior " + this.props.informacionJunta.numeroExterior + 
                                (this.props.informacionJunta.numeroInterior ? ", No. Interior " + this.props.informacionJunta.numeroInterior : "") +
                                ", Col. " + this.props.informacionJunta.colonia + ", C.P. " + this.props.informacionJunta.codigoPostal +
                                ", " + this.props.informacionJunta.nombreMunicipio + ", " + this.props.informacionJunta.nombreEstado + "."
                                : "-"
                            }
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_REFERENCIAS}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {this.props.informacionJunta && this.props.informacionJunta.referencias ? this.props.informacionJunta.referencias : "-"}
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_TELEFONO}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {this.props.informacionJunta && this.props.informacionJunta.telefono ? 
                                this.props.informacionJunta.telefono + 
                                    (this.props.informacionJunta.extension ? ' ext. ' + this.props.informacionJunta.extension : '') 
                                : "-"}
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_RESPONSABLE}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {
                                this.props.informacionJunta && this.props.informacionJunta.tratamiento && this.props.informacionJunta.nombres ? 
                                    this.props.informacionJunta.tratamiento + " " + this.props.informacionJunta.nombres + " " +
                                    (this.props.informacionJunta.primerApellido ? this.props.informacionJunta.primerApellido + ' ' : '') + 
                                    (this.props.informacionJunta.segundoApellido ? this.props.informacionJunta.segundoApellido + ' ' : '')
                                : "-"
                            }
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_nombres_campos">
                            {etiquetas.ETIQUETA_JUNTA_EJECUTIVA_CORREO_ELECTRONICO}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} className="columna2_valores_campos">
                            {this.props.informacionJunta && this.props.informacionJunta.correo ? this.props.informacionJunta.correo : "-"}
                        </Col>
                    </Col>
                </Col>

                <Col xs={18} sm={18} md={18} lg={18} offset={4} className="botones_junta_ejecutiva">
                    <Button type="primary"
                        //disabled={this.props.informacionJunta === undefined}
                        onClick = {this.props.onClickBtnModificar}
                    >
                        { !this.props.informacionJunta || !this.props.informacionJunta.calle || !this.props.informacionJunta.numeroExterior ||
                        !this.props.informacionJunta.colonia || !this.props.informacionJunta.codigoPostal ? 
                            etiquetas.general_btn_agregar : 
                            etiquetas.general_btn_modificar }
                    </Button>
                </Col>
          </Row>
        );
    }
}

export default JuntaEjecutivaConsulta;